/**
 * Configuración del seguimiento de formularios.
 *
 * Los slugs tienen que coincidir con src/constants/formTracking.js del backend.
 * Para sumar un formulario nuevo alcanza con agregar una entrada en
 * TRACKING_FORMS (y su form_type en el backend); el modal y la columna de
 * estado se arman solos a partir de esta config.
 */
export const TRACKING_STATUS_OPTIONS = [
  { slug: 'contactado', nombre: 'Contactado', color: 'is-info' },
  { slug: 'segundo-toque', nombre: '2do toque', color: 'is-link' },
  { slug: 'tercer-toque', nombre: '3er toque', color: 'is-primary' },
  { slug: 'rechazado', nombre: 'Rechazado', color: 'is-danger' },
  { slug: 'no-responde', nombre: 'No responde', color: 'is-warning' },
  { slug: 'cerro-venta', nombre: 'Cerró venta', color: 'is-success' }
]

export const TRACKING_CONTACT_METHOD_OPTIONS = [
  { slug: 'whatsapp', nombre: 'WhatsApp' },
  { slug: 'llamada', nombre: 'Llamada' },
  { slug: 'mail', nombre: 'Mail' },
  { slug: 'cara-a-cara', nombre: 'Cara a cara' },
  { slug: 'dashboard', nombre: 'Dashboard' },
  { slug: 'numero-invalido', nombre: 'Número inválido' }
]

export const TRACKING_REJECTION_REASON_OPTIONS = [
  { slug: 'por-precio', nombre: 'Por precio' },
  { slug: 'no-acepta-oferta', nombre: 'No acepta oferta' },
  { slug: 'fuera-de-catalogo', nombre: 'Fuera de catálogo' },
  { slug: 'ya-lo-vendio', nombre: 'Ya lo vendió' },
  { slug: 'no-le-interesa', nombre: 'Ya no le interesa' },
  { slug: 'otro', nombre: 'Otro' }
]

/**
 * El orden define la grilla del modal (dos campos por fila). Motivo de rechazo
 * va justo después de Estado: cuando aparece se ubica al lado y empuja Medio de
 * contacto a la fila siguiente.
 */
const LEAD_TRACKING_FIELDS = [
  {
    key: 'assigned_admin_id',
    label: 'Responsable',
    type: 'select',
    optionsSource: 'admins'
  },
  {
    key: 'is_contacted',
    label: '¿Contactado?',
    type: 'boolean',
    checkboxLabel: 'El lead fue contactado'
  },
  {
    key: 'status',
    label: 'Estado',
    type: 'select',
    options: TRACKING_STATUS_OPTIONS
  },
  {
    key: 'rejection_reason',
    label: 'Motivo de rechazo',
    type: 'select',
    options: TRACKING_REJECTION_REASON_OPTIONS,
    showWhen: (formData) => formData.status === 'rechazado'
  },
  {
    key: 'contact_method',
    label: 'Medio de contacto',
    type: 'multiselect',
    options: TRACKING_CONTACT_METHOD_OPTIONS
  },
  {
    key: 'notes',
    label: 'Notas',
    type: 'textarea',
    fullWidth: true
  }
]

export const TRACKING_FORMS = {
  landing: LEAD_TRACKING_FIELDS
}

export const trackingStatusLabel = (slug) => {
  const status = TRACKING_STATUS_OPTIONS.find(item => item.slug === slug)
  return status ? status.nombre : ''
}

export const trackingStatusColor = (slug) => {
  const status = TRACKING_STATUS_OPTIONS.find(item => item.slug === slug)
  return status ? status.color : 'is-light'
}
